import * as React from 'react';
import { Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { AccuracyWeaponCategories, MatchRoundAccuracyStatsCategories } from '../../../../../helpers';

interface MatchOverallWeaponsAccuracyCategoriesTabsProps {
    activeCategoryTab: AccuracyWeaponCategories,
    setActiveCategoryTab: React.Dispatch<React.SetStateAction<AccuracyWeaponCategories>>;
    categories: MatchRoundAccuracyStatsCategories[];
    setCategory: React.Dispatch<React.SetStateAction<MatchRoundAccuracyStatsCategories>>;
    activeWeapon: string;
    setActiveWeapon: React.Dispatch<React.SetStateAction<string>>;
};

const MatchOverallWeaponsAccuracyCategoriesTabs = (props: MatchOverallWeaponsAccuracyCategoriesTabsProps) => {

    const toggle = (tab: AccuracyWeaponCategories, category: MatchRoundAccuracyStatsCategories) => {
        if (props.activeCategoryTab !== tab)
        {
            // Change the weapon tab if that weapon doesn't exist in our new selected category.
            if (category.AccuracyWeaponCategories.find(f => f === props.activeWeapon) === undefined) {
                props.setActiveWeapon(category.AccuracyWeaponCategories[0] || "");
            }
            props.setActiveCategoryTab(tab);
            props.setCategory(category);
        }
    };

    return (
        <React.Fragment>
            {props.categories.length > 0 && (
                <Row className='mb-3'>
                    <Col>
                        <Nav tabs>
                            {props.categories.map((s, idx) => (
                                <NavItem key={idx}>
                                    <NavLink
                                        className={classnames({ active: props.activeCategoryTab === s.category })}
                                        onClick={() => { toggle(s.category, s); }}
                                    >
                                        {s.category}
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                    </Col>
                </Row>
            )}
        </React.Fragment>);
};

export default MatchOverallWeaponsAccuracyCategoriesTabs;